import {createUseStyles} from "react-jss";
import {colors} from "../../constants/colors";

const styles = createUseStyles(theme => ({
  container:{
    display: "flex",
    alignItems: "center",
  },
  border:{
    width: "100%",
  },
  dividerContent: {
    fontSize: "14px",
    fontFamily: theme.fontFamily,
    color: colors.mediumGrey,
    fontWeight:"500",
    lineHeight:"20px",
    padding: "0px 8px",
  },
}));

export default styles;
